import Image from 'next/image';
import Link from 'next/link';

import { Card } from 'components/slider/cards/medium';
import { Header } from 'components/slider/header';
import { IBlogPost, ICasino } from 'constants/types';

import { Markdown } from 'common/markdown-components';

import { Icon } from 'common/icon';

import { Routes } from 'constants/routes';
import dayjs from 'dayjs';
import { useTrustedCasinos } from 'hooks';
import { shuffle } from 'lodash';

import { Guide } from 'assets/icons/guide';
import clsx from 'clsx';
import { useMemo } from 'react';
import styles from './styles.module.css';

const BlockAuthor = ({ data }: { data: IBlogPost }) => {
  const { url, type } = useMemo(() => {
    switch (data?.type) {
      case 'guide':
        return { url: Routes.guides, type: 'Guides' };
      case 'topic':
        return { url: Routes.news, type: 'News' };
      default:
        return { url: '', type: '' };
    }
  }, [data?.type]);

  return (
    <div className={styles.blog_post__date_author}>
      <Link href={url} className={clsx(styles.blog_post_type)}>
        <div className={styles.typeContainer}>
          <Guide />
          <span className={styles.typeText}>{type}</span>
        </div>
      </Link>
      <div className={styles.separator} />
      <div className={clsx(styles.blog_post__date)}>
        <Icon.Calendar />
        <span>{dayjs(data.last_modified).format('DD MMM, YYYY')}</span>
      </div>
      <div className={styles.separator} />
      <div className={styles.blog_post__author}>
        <Icon.Author />
        <span>{data.author ?? 'Unknown'}</span>
      </div>
    </div>
  );
};

export const Post = ({ data }: { data: IBlogPost }) => {
  const { trustedCasinos, trustedCasinosCount } = useTrustedCasinos();

  let first: ICasino | undefined;
  let second: ICasino | undefined;

  if (trustedCasinos && Array.isArray(trustedCasinos)) {
    [first, second] = shuffle(trustedCasinos);
  }

  return (
    <section key={data?._id?.toString()} className={styles.blog_post}>
      <div className={styles.container_s}>
        <div className={styles.blog_post__header_image}>
          <Image
            width={600}
            height={340}
            alt={`post-${data._id}`}
            src={data?.imageUrl ?? ''}
            style={{ width: '100%', height: 'auto' }}
          />

          <div className={styles.blog_post__logo}>
            <Icon.LogoPost />
            <span>RTPi</span>
          </div>
        </div>
        <div className={styles.blog_post__row}>
          <div className={styles.blog_post__content}>
            <div className={styles.blog_post__content_top}>
              <h1 className={styles.blog_post__title}>{data.title}</h1>
              <BlockAuthor data={data} />
            </div>
            <div className={styles.blog_post__text}>
              <Markdown data={data.content} />
            </div>
          </div>
          <div className={styles.blog_post__sidebar}>
            <div className={styles.blog_post__casinos}>
              <Header
                name="Casinos"
                count={trustedCasinosCount?.toString()}
                url={Routes.casinoCollections('trusted-casinos')}
              />
              <div className={styles.blog_post__casinos_row}>
                {first && <Card data={first} />}
                {second && <Card data={second} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
